var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"10","width":"10","viewBox":"0 0 10 10"}},[_c('polygon',{staticStyle:{"fill":"#F0BC35","stroke":"#F0BC35","stroke-width":"1"},attrs:{"points":"0,0 5,10 10,0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }